import axios from "axios";

var InteractionMonograph = {
    initializeHeaders: function (headers) {
        axios.defaults.headers.common = headers;
    },
    get: function (interactionId, params) {
        console.log('InteractionMonograph Model');
        return axios.get(
            Apollo.resolveApiUrl("~/monograph/interaction/" + interactionId),
            {
                params: params

            });
    }
};

export default InteractionMonograph;


// WEBPACK FOOTER //
// ./src/models/InteractionMonograph.js